// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_55-0";
export var eligibilityCardNotEligible = "_55-1";